import { AfterViewInit, Directive, ElementRef, HostBinding, Input, OnChanges, SimpleChanges } from '@angular/core';
import { SwiperOptions } from 'swiper/types/swiper-options';

@Directive({
	selector: '[swiperElement]',
})
export class SwiperDirective implements AfterViewInit, OnChanges {
	@HostBinding('attr.init') init = 'false';
	@Input() config?: SwiperOptions;
	private readonly swiperElement: any;
	private initialized = false;

	constructor(private element: ElementRef) {
		this.swiperElement = element.nativeElement;
	}

	ngAfterViewInit(): void {
		this.applyConfig();
		this.initializeSwiper();
	}

	ngOnChanges(changes: SimpleChanges): void {
		if (!changes['config'] || !this.initialized || !this.swiperElement?.swiper?.params) {
			return;
		}

		Object.assign(this.swiperElement.swiper.params, this.config ?? {});
		this.swiperElement.swiper.update?.();
	}

	private applyConfig(): void {
		if (!this.config) {
			return;
		}

		Object.assign(this.swiperElement, this.config);
	}

	private initializeSwiper(): void {
		if (this.initialized) {
			return;
		}

		try {
			if (typeof this.swiperElement?.initialize === 'function') {
				this.swiperElement.initialize();
			}

			if (this.swiperElement?.swiper && this.config) {
				Object.assign(this.swiperElement.swiper.params ?? {}, this.config);
				this.swiperElement.swiper.update?.();
			}

			this.initialized = true;
		} catch (error) {}
	}
}
